import _debounce from 'lodash/debounce';
import _camelCase from 'lodash/camelCase';
import InstanceMgr from '../managers/InstanceMgr';
import Component from './Component';

// class
export default class App extends Component {

    // constructor
    constructor(args = {}) {
        
        // call super
        super(args);

        // set properties
        this._instances = new InstanceMgr({
            $parentNode: this._$el
        });

        this._debouncers = {
            resize: {
                timers: {
                    debunce: null,
                    delay: null
                }
            },
            scroll: {
                timers: {
                    debunce: null,
                    delay: null
                }
            }
        }
        this._mediaQueries = [
            { name: 'ready',        query: '(min-width: 0em)' },
            ...(args.mediaQueries || [])
        ];


        // add resize & scroll listeners with extra data for debouncing & delaying using bind
        window.addEventListener('resize', onWindowEvent.bind(this, {
            timers: this._debouncers.resize.timers,
            instantCallback: this.resize,
            debounceCallback: this.debouncedResize,
            delayCallback: this.delayedResize
        }));
        
        window.addEventListener('scroll', onWindowEvent.bind(this, {
            timers: this._debouncers.scroll.timers,
            instantCallback: this.scroll,
            debounceCallback: this.debouncedScroll,
            delayCallback: this.delayedScroll
        }));

        // launch mediquery check for a first time
        checkMediaQueries.call(this, {
            event: 'init'
        });


        // set ready class to prevent extra init   
    }

    // methods
    initReady (args = {}) {
        // // ready overrides component ready getter/setter
        // this._$el.classList.add('--ready');
        this.isReady = true;
    }


    resize () {

    }

    debouncedResize () {

    }

    delayedResize() {

    }

    scroll () {

    }

    debouncedScroll () {

    }

    delayedScroll () {

    }

    // getters & setters
    get instances () {
        return this._instances;
    }
}

// utils
export function checkMediaQueries(args = {}, options = {}) {
    const destroyMethods = [];
    const initMethods = [];

    // make up init and destory lists so they can run every destroy before every init
    for (const def of this._mediaQueries) {
        const mql = window.matchMedia(def.query);

        if (mql.matches !== def.matches || options.force === true) {
            def.matches = mql.matches;

            // determine method name
            const methodName = _camelCase(`${def.matches ? 'init' : 'destroy'} ${def.name}`);

            // look for method to excecute before calling it
            if (this[methodName]) {
                const methodInfo = {
                    name: methodName,
                    params: {
                        mql,
                        type: args.type || (mql.matches ? 'init' : 'destroy'),
                        event: args.event
                    }
                }

                // add key to params
                methodInfo.params.key = `${methodInfo.params.type}:${methodInfo.params.event}`;

                if (def.matches) {
                    initMethods.push(methodInfo);
                }
                else {
                    destroyMethods.push(methodInfo);
                }
            }
        }
    }
    
    // run destroys
    for (const methodInfo of destroyMethods) {
        this[methodInfo.name](methodInfo.params);
    }
    
    // run inits
    for (const methodInfo of initMethods) {
        this[methodInfo.name](methodInfo.params);
    }
}

function updateDebounceTimer(timerObj, callback) {
    if (!timerObj.debounce) {
        timerObj.debounce = setTimeout(onDebouncedMethod.bind(this, timerObj, callback), 100);
    }
} 

function updateDelayTimer(timerObj, callback) {
    // delayed callback (if already set, clear timeout & set new one)
    if (timerObj.delay) {
        clearTimeout(timerObj.delay);
    }

    timerObj.delay = setTimeout(onDelayMethod.bind(this, timerObj, callback), 100);
}

// listeners
function onWindowEvent(args, e) {
    checkMediaQueries.call(this, {
        event: 'resize'
    });

    // immediat resize callback
    args.instantCallback.call(this);

    // debounced callback (set timeout if not already set)
    updateDebounceTimer.call(this, args.timers, args.debounceCallback);
    
    // delayed callback (if already set, clear timeout & set new one)
    updateDelayTimer.call(this, args.timers, args.delayCallback);
}

function onDebouncedMethod(timerObj, callback) {
    timerObj.debounce = null;
    callback.call(this);
}

function onDelayMethod(timerObj, callback) {
    timerObj.debounce = null;
    callback.call(this);
}
